import { products } from "../data/products";
import ProductCard from "../components/ProductCard";
import HeroBanner from "../components/HeroBanner";
import { Link } from "react-router-dom";
import { useRecentlyViewed } from "../Context/RecentlyViewedContext";

export default function Home() {
  const { viewedProductIds } = useRecentlyViewed();
  const trending = products.filter(p => p.rating >= 4.7);
  const bestsellers = products.filter(p => p.bestseller);
  const dealOfTheDay = products.find(p => p.id === "o1");

  // Map stored IDs to product data, removing any unknown products
  const recentlyViewedProducts = viewedProductIds
    .map(id => products.find(p => p.id === id))
    .filter((p): p is typeof products[0] => p !== undefined);

  return (
    <div className="container">
      <HeroBanner />

      {dealOfTheDay && (
        <div className="card" style={{ marginBottom: '24px', background: 'linear-gradient(to right, #fbf8cc, #fde4cf)' }}>
           <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
              <h2 style={{ margin: 0, color: '#d00000' }}>🔥 Deal of the Day</h2>
              <span style={{ fontWeight: 'bold', color: '#d00000' }}>Ends in 05h 23m 12s</span>
           </div>
           
           <div style={{ display: 'flex', gap: '24px', alignItems: 'center', flexWrap: 'wrap' }}>
             <img src={dealOfTheDay.imageUrl} alt={dealOfTheDay.name} style={{ width: '150px', height: '150px', objectFit: 'cover', borderRadius: '8px', border: '1px solid var(--border)' }} />
             <div>
                <h3 style={{ margin: '0 0 8px 0' }}>{dealOfTheDay.name}</h3>
                <p style={{ margin: '0 0 12px 0' }}>{dealOfTheDay.description}</p>
                <div style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '16px' }}>₹{dealOfTheDay.price} <span style={{ textDecoration: 'line-through', color: 'var(--text-muted)', fontSize: '16px' }}>₹{dealOfTheDay.originalPrice}</span></div>
                <Link to={`/product/${dealOfTheDay.id}`} className="btn-primary">Claim Deal Now</Link>
             </div>
           </div>
        </div>
      )}

      <h2>Bestsellers</h2>
      <div className="grid">
        {bestsellers.map(product => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>

      <h2 style={{ marginTop: '28px' }}>Trending Top Rated</h2>
      <div className="grid">
        {trending.map(product => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>

      {recentlyViewedProducts.length > 0 && (
        <>
          <h2 style={{ marginTop: '28px' }}>Recently Viewed Items</h2>
          <div style={{ display: 'flex', gap: '20px', overflowX: 'auto', paddingBottom: '16px' }}>
            {recentlyViewedProducts.map(product => (
              <div key={product.id} style={{ minWidth: '220px', flexShrink: 0 }}>
                <ProductCard product={product} />
              </div>
            ))}
          </div>
        </>
      )}

      <h2 style={{ marginTop: '28px' }}>Explore Categories</h2>
      <div className="grid">
        {[
          { title: "Pooja Essentials", img: "https://images.unsplash.com/photo-1601004890684-d8cbf643f5f2?auto=format&fit=crop&q=80&w=200" },
          { title: "Aquariums & Pets", img: "https://images.unsplash.com/photo-1522069169874-c58ec4b76be5?auto=format&fit=crop&q=80&w=200" },
          { title: "Ayurvedic Oils", img: "https://images.unsplash.com/photo-1608248593842-8d760777eaf3?auto=format&fit=crop&q=80&w=200" },
          { title: "Decorative Flowery", img: "https://images.unsplash.com/photo-1655823791102-1d57579f64db?auto=format&fit=crop&q=80&w=200" },
        ].map((cat, idx) => (
          <div key={idx} className="card" style={{ padding: 0, overflow: 'hidden' }}>
            <img src={cat.img} alt={cat.title} style={{ width: '100%', height: '140px', objectFit: 'cover' }} />
            <div style={{ padding: '12px', textAlign: 'center', fontWeight: 'bold' }}>{cat.title}</div>
          </div>
        ))}
      </div>

      {/* Value Propositions */}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', justifyContent: 'space-around', margin: '32px 0', borderTop: '1px solid var(--border)', paddingTop: '16px' }}>
         <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '32px', marginBottom: '8px' }}>🚚</div>
            <div style={{ fontWeight: 'bold' }}>Free Delivery</div>
            <div style={{ fontSize: '14px', color: 'var(--text-muted)' }}>On orders above ₹499</div>
         </div>
         <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '32px', marginBottom: '8px' }}>🛡️</div>
            <div style={{ fontWeight: 'bold' }}>100% Genuine</div>
            <div style={{ fontSize: '14px', color: 'var(--text-muted)' }}>Sourced from original vendors</div>
         </div>
         <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '32px', marginBottom: '8px' }}>💳</div>
            <div style={{ fontWeight: 'bold' }}>Secure Payments</div>
            <div style={{ fontSize: '14px', color: 'var(--text-muted)' }}>Encrypted & Safe</div>
         </div>
         <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '32px', marginBottom: '8px' }}>↩️</div>
            <div style={{ fontWeight: 'bold' }}>Easy Returns</div>
            <div style={{ fontSize: '14px', color: 'var(--text-muted)' }}>7-day hassle free returns</div>
         </div>
      </div>
    </div>
  );
}
